
import { useState } from 'react'
import { FaPencilAlt, FaTrashAlt } from 'react-icons/fa'

import Modal from '../../../shared/modal/Modal'
import ConfirmDeleteModal from '../../../shared/components/ConfirmDeleteModal/ConfirmDeleteModal'
import api from '../../../utils/api'

import EditSizeGrid from '../EditSizeGrid'

/* Hooks */
import useFlashMessage from '../../../hooks/useFlashMessage'


function ListSizeGridRow({ dataArray, myPermissionView, myPermissionEdit, myPermissionDelete, handleOnSuccess }) {

    const [token] = useState(localStorage.getItem('token') || '')
    const { setFlashMessage } = useFlashMessage()

    /* ------------------- Modal useState ----------------------*/

    const [modalEditSizeGrid, setModalEditSizeGrid] = useState(false)
    const [sizeGridId, setSizeGridId] = useState("")
    const [modalDeleteItem, setModalDeleteItem] = useState(false)
    const [sizeGridName, setSizeGridName] = useState("")

    async function deleteSizeGrid(id) {
        let msgType = 'success'
        const data = await api.delete(`/sizeGrid/delete/${id}`, {
            headers: {
                Authorization: `Bearer ${JSON.parse(token)}`,
            },
        }).then((response) => {
            if (response) {
                handleOnSuccess()
                setModalDeleteItem(false)
            }

            return response.data
        }).catch((err) => {

            msgType = 'error'
            return err.response.data
        })

        setFlashMessage(data.message, msgType)
    }

    /* ------------------------ cards ------------------------------ */
    const listArray = () => {
        if (myPermissionView && dataArray && dataArray.length > 0) {
            return dataArray.map((item) => (
                <div key={item._id} className='pg-item'>
                    <div className='pg-item-main'>
                        <span className='pg-item-name'>{item.name}</span>
                    </div>

                    <div className='shd-row-box-item-action'>
                        {myPermissionEdit &&
                            <FaPencilAlt className='shd-icon-row-edit' title='Editar' onClick={() => { setSizeGridId(item._id); setModalEditSizeGrid(true) }} />
                        }
                        {myPermissionDelete &&
                            <FaTrashAlt className='shd-icon-row-trash' title='Apagar' onClick={() => { setModalDeleteItem(true); setSizeGridId(item._id); setSizeGridName(item.name) }} />
                        }
                    </div>
                </div>
            ))
        }
    }

    return (
        <div>
            {listArray()}

            <Modal
                modalStatus={modalEditSizeGrid}
                changeStatus={setModalEditSizeGrid}
                w={82}
                content={
                    <EditSizeGrid id={sizeGridId} handleOnSuccess={() => { setModalEditSizeGrid(false); handleOnSuccess() }} btCancelAction={() => setModalEditSizeGrid(false)} />
                }
            />

            <ConfirmDeleteModal
                modalStatus={modalDeleteItem}
                changeStatus={setModalDeleteItem}
                onConfirm={() => deleteSizeGrid(sizeGridId)}
                message="Deseja realmente excluir essa grade?"
                itemName={sizeGridName}
            />

        </div>
    )
}

export default ListSizeGridRow
